/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CounselorPresenceResponse
 */
export interface CounselorPresenceResponse {
    /**
     * 
     * @type {string}
     * @memberof CounselorPresenceResponse
     */
    counselorId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CounselorPresenceResponse
     */
    isPresent: boolean;
}

/**
 * Check if a given object implements the CounselorPresenceResponse interface.
 */
export function instanceOfCounselorPresenceResponse(value: object): value is CounselorPresenceResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('isPresent' in value) || value['isPresent'] === undefined) return false;
    return true;
}

export function CounselorPresenceResponseFromJSON(json: any): CounselorPresenceResponse {
    return CounselorPresenceResponseFromJSONTyped(json, false);
}

export function CounselorPresenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CounselorPresenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'isPresent': json['isPresent'],
    };
}

export function CounselorPresenceResponseToJSON(json: any): CounselorPresenceResponse {
    return CounselorPresenceResponseToJSONTyped(json, false);
}

export function CounselorPresenceResponseToJSONTyped(value?: CounselorPresenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'isPresent': value['isPresent'],
    };
}

